import React, { useEffect } from 'react'
import { useVerifyOtpMutation } from '../../../../services/cellcast'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useQuery } from '../../../hooks/useLocationQuery';
import Spinner from '../../../Components/Spinner';
import PageLoading from '../../../routing/PageLoading';


const VerifyOtp = () => {
    const query = useQuery()
    const navigate = useNavigate()
    const [verifyOtp, { isLoading }] = useVerifyOtpMutation()
    const email = query.get('email')
    const shortCode = query.get('shortCode')


    useEffect(() => {
        verifyOtp({
            "code": shortCode,
            "email": email,
            "type": "SIGNUP_EMAIL"
        }).unwrap()
            .then(res => {
                toast.success('email success verified')
                navigate('/auth')
            })
            .catch(err => {
                toast.error('wrong verification code')
                navigate('/auth')
            })
    }, [])

    return (
        <div className='m-auto'>
            <div className='text-center'>
                {isLoading && <PageLoading />}
                <h1>Verify Email</h1>
            </div>
        </div>
    )
}

export default VerifyOtp